var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.375,
    y: 1.375,
    width: 19.25,
    height: 19.25,
    rx: 9.625,
    fill: "#1275B1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.67526 6.66335C8.67526 7.30585 8.11835 7.8267 7.43138 7.8267C6.7444 7.8267 6.1875 7.30585 6.1875 6.66335C6.1875 6.02085 6.7444 5.5 7.43138 5.5C8.11835 5.5 8.67526 6.02085 8.67526 6.66335Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3576 8.68182H8.48389V15.125H6.3576V8.68182Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9072 8.68182H9.78093V15.125H11.9072C11.9072 15.125 11.9072 13.0966 11.9072 11.8283C11.9072 11.0671 12.1671 10.3026 13.2043 10.3026C14.3763 10.3026 14.3693 11.2987 14.3638 12.0705C14.3567 13.0793 14.3737 14.1088 14.3737 15.125H16.5V11.7244C16.482 9.55307 15.9162 8.55256 14.0548 8.55256C12.9493 8.55256 12.2641 9.05442 11.9072 9.50846V8.68182Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLd);
export default __webpack_public_path__ + "static/media/ld.f6ceffc014e9c7961eef8ea1794cf602.svg";
export { ForwardRef as ReactComponent };